import RestAPI from '../restApiService';

class AuthAPI {
  postLogin = (data: { Username: string; Password: string }): Promise<any> =>
    RestAPI.post('/auth/login', data);
}

export default new AuthAPI();
